import {
    DynamicNumberButton,
    DynamicNumberLink
} from './DynamicPhoneNumber.styles';
import { Variant } from '@blueprint/button/src/Button.types';

type DynamicPhoneNumberProps = {
    buttonVariant?: Variant;
    phone?: string | null;
    onClickToCall: () => void;
    onClickToReveal: () => void;
} & React.ButtonHTMLAttributes<HTMLButtonElement> &
    React.AnchorHTMLAttributes<HTMLAnchorElement>;

export const DynamicPhoneNumber: React.FC<
    React.PropsWithChildren<DynamicPhoneNumberProps>
> = ({
    buttonVariant = 'tertiary',
    phone,
    onClickToCall,
    onClickToReveal,
    children,
    disabled,
    ...props
}) => {
    return phone ? (
        <DynamicNumberLink
            href={phone ? `tel:${phone}` : ''}
            onClick={onClickToCall}
            variant={buttonVariant || 'tertiary'}
            {...props}
        >
            {children}
        </DynamicNumberLink>
    ) : (
        <DynamicNumberButton
            onClick={onClickToReveal}
            variant={buttonVariant || 'tertiary'}
            disabled={disabled}
            {...props}
        >
            {children}
        </DynamicNumberButton>
    );
};
